import { checkEmail } from './Rules'

export default {
    contactFirstName: [{ required: true, message: Loc.g('Veuillez renseigner un prénom valide'), trigger: 'blur' }],
    contactName: [{ required: true, message: Loc.g('Veuillez renseigner un nom valide'), trigger: 'blur' }],
    contactEmail: [
        { required: true, message: Loc.g('Veuillez renseigner une adresse email valide'), trigger: 'blur' },
        { validator: checkEmail, trigger: 'blur' },
    ],
    contactPhone: [{ required: true, message: Loc.g('Veuillez renseigner un numéro de téléphone valide'), trigger: 'blur' }],
    locale: [{ required: true, message: Loc.g('Veuillez sélectionner une langue de facturation valide'), trigger: 'blur' }],
}